import { create } from "zustand";

type Props = {
  drawerState: boolean;
  toggleDrawerState: () => void;
};

const useDrawer = create<Props>((set) => ({
  drawerState: false,
  toggleDrawerState: () =>
    set((state) => ({ drawerState: !state.drawerState })),
}));

export default useDrawer;
